<template>
  <el-dialog :visible.sync="visible" title="添加告警设置" width="650px" custom-class="alarm-dialog" @close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="alarm-form">
      <el-form-item label="小区" prop="communityId">
        <el-select v-model="form.communityId" placeholder="请选择" style="width:100%" filterable>
          <el-option v-for="item in communityList" :key="item.communityId" :label="item.name" :value="item.communityId" />
        </el-select>
      </el-form-item>
      <el-form-item label="告警类型" prop="alarmTypeCd">
        <el-select v-model="form.alarmTypeCd" placeholder="请选择" style="width:100%" :loading="alarmTypeLoading" filterable>
          <el-option v-for="item in alarmTypeOptions" :key="item.alarmTypeCd" :label="item.alarmTypeName" :value="item.alarmTypeCd" />
        </el-select>
      </el-form-item>
      <el-form-item label="告警级别" prop="alarmLevel">
        <el-select v-model="form.alarmLevel" placeholder="请选择" style="width:100%">
          <el-option label="高" value="HIGH" />
          <el-option label="中" value="MEDIUM" />
          <el-option label="低" value="LOW" />
        </el-select>
      </el-form-item>
      <el-form-item label="处理人员" prop="defaultHandlerId">
        <el-select v-model="form.defaultHandlerId" placeholder="请选择" style="width:100%" filterable multiple collapse-tags>
          <el-option v-for="staff in staffOptions" :key="staff.userId" :label="staff.userName || staff.name" :value="staff.userId" />
        </el-select>
      </el-form-item>
      <el-form-item label="办理时长" prop="handleTime">
        <el-autocomplete
          v-model="handleTimeDisplay"
          :fetch-suggestions="getHandleTimeSuggestions"
          placeholder="请输入"
          style="width:100%"
          value-key="label"
          @select="handleSelectTime"
        >
          <template slot="append">分钟</template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="超时预警" prop="overtimeWarning">
        <el-input v-model.number="form.overtimeWarning" placeholder="请输入" style="width:100%">
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>
      <el-form-item label="回访设置" prop="returnVisitFlag">
        <el-select v-model="form.returnVisitFlag" placeholder="请选择" style="width:100%">
          <el-option label="需要回访" value="Y" />
          <el-option label="不需要回访" value="N" />
        </el-select>
      </el-form-item>
      <el-form-item label="说明" prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请输入" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="alarm-btn-cancel" @click="visible = false">取消</el-button>
      <el-button class="alarm-btn-confirm" type="primary" :loading="loading" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId, getMyEnteredCommunitys } from '@/api/community/communityApi'
import { getStaffInfos } from '@/api/work/repairTypeUserApi'
import { saveAlarmSetting } from '@/api/inspection/alarmSettingManageApi'
import { listAlarmTypeMappings } from '@/api/inspection/alarmTypeMappingApi'

export default {
  name: 'AddAlarmSetting',
  data() {
    return {
      visible: false,
      loading: false,
      staffLoading: false,
      alarmTypeLoading: false,
      communityList: [],
      alarmTypeOptions: [],
      form: {
        communityId: '',
        alarmTypeCd: '',
        alarmLevel: '',
        defaultHandlerId: [],
        handleTime: null,
        overtimeWarning: null,
        returnVisitFlag: 'Y',
        remark: ''
      },
      rules: {
        communityId: [{ required: true, message: '请选择小区', trigger: 'change' }],
        alarmTypeCd: [{ required: true, message: '请选择告警类型', trigger: 'change' }],
        alarmLevel: [{ required: true, message: '请选择告警级别', trigger: 'change' }],
        defaultHandlerId: [{ required: true, message: '请选择处理人员', trigger: 'change', type: 'array' }],
        handleTime: [{ required: true, message: '请输入办理时长', trigger: 'blur' }],
        overtimeWarning: [{ required: true, message: '请输入超时预警', trigger: 'blur' }],
        returnVisitFlag: [{ required: true, message: '请选择回访设置', trigger: 'change' }]
      },
      staffOptions: []
    }
  },
  watch: {
    'form.communityId'(newVal) {
      if (newVal) {
        this.form.defaultHandlerId = []
        this.loadStaffOptions()
      }
    },
    'form.handleTime'(newVal) {
      // 监听办理时长变化，自动计算超时预警时间
      if (newVal && !isNaN(newVal) && newVal > 0) {
        const handleTimeInMinutes = newVal // 后端已改为分钟，无需转换
        // 根据规则设置预警时间（预警时间点，非剩余时间）
        if (handleTimeInMinutes === 10 || handleTimeInMinutes === 20) {
          this.form.overtimeWarning = 5 // 10分钟和20分钟都是5分钟预警
        } else if (handleTimeInMinutes === 30 || handleTimeInMinutes === 45) {
          this.form.overtimeWarning = 10 // 30分钟和45分钟都是10分钟预警
        } else {
          // 其他自定义时长，使用动态规则
          if (handleTimeInMinutes <= 20) {
            this.form.overtimeWarning = 5
          } else {
            this.form.overtimeWarning = 10
          }
        }
      } else {
        this.form.overtimeWarning = null
      }
    }
  },
  computed: {
    // 办理时长的字符串显示（用于 el-autocomplete）
    // 后端存储的是分钟，前端也使用分钟
    handleTimeDisplay: {
      get() {
        if (this.form.handleTime === null || this.form.handleTime === undefined) {
          return ''
        }
        return String(this.form.handleTime)
      },
      set(value) {
        if (!value) {
          this.form.handleTime = null
          return
        }
        this.form.handleTime = Number(value)
      }
    }
  },
  methods: {
    async open() {
      await Promise.all([this.loadCommunityList(), this.loadAlarmTypeOptions()])
      const defaultCommunityId = getCommunityId()
      this.form.communityId = defaultCommunityId && defaultCommunityId !== '-1' ? defaultCommunityId : ''
      this.visible = true
      if (this.form.communityId) {
        this.loadStaffOptions()
      }
    },
    async loadCommunityList() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communityList = (res.communitys || res.data || []).map(item => ({
          ...item,
          communityId: String(item.communityId)
        })).filter(item => item.communityId && item.communityId !== '-1')
      } catch (error) {
        console.error('加载小区列表失败:', error)
        this.communityList = []
      }
    },
    async loadAlarmTypeOptions() {
      this.alarmTypeLoading = true
      try {
        const res = await listAlarmTypeMappings({ page: 1, row: 100, statusCd: '0' })
        const list = res.list || []
        // 同一告警类型可能对应多个消息来源，按告警类型名称去重
        const uniqueMap = new Map()
        list.forEach(item => {
          if (item.alarmTypeName && !uniqueMap.has(item.alarmTypeName)) {
            uniqueMap.set(item.alarmTypeName, item)
          }
        })
        this.alarmTypeOptions = Array.from(uniqueMap.values())
      } catch (error) {
        this.$message.error(error.message || '获取告警类型列表失败')
        this.alarmTypeOptions = []
      } finally {
        this.alarmTypeLoading = false
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.form = {
        communityId: '',
        alarmTypeCd: '',
        alarmLevel: '',
        defaultHandlerId: [],
        handleTime: null,
        overtimeWarning: null,
        returnVisitFlag: 'Y',
        remark: ''
      }
      this.staffOptions = []
      this.communityList = []
      this.alarmTypeOptions = []
    },
    async loadStaffOptions() {
      if (!this.form.communityId) {
        console.log('未选择小区，无法加载人员')
        return
      }
      console.log('开始加载小区人员，communityId:', this.form.communityId)
      this.staffLoading = true
      try {
        const res = await getStaffInfos({
          communityId: this.form.communityId,
          page: 1,
          row: 1000
        })
        console.log('加载到的人员列表:', res)
        // 处理不同的返回格式
        const staffList = res.staffs || res.data || (Array.isArray(res) ? res : [])
        this.staffOptions = Array.isArray(staffList) ? staffList : []
        console.log('处理后的 staffOptions:', this.staffOptions)
      } catch (error) {
        console.error('获取人员列表失败:', error)
        this.$message.error(error.message || '获取人员列表失败')
        this.staffOptions = []
      } finally {
        this.staffLoading = false
      }
    },
    async handleSubmit() {
      if (this.loading) return // 防止重复提交

      this.$refs.form.validate(async valid => {
        if (!valid) return

        if (this.loading) return // 二次检查
        this.loading = true

        try {
          const payload = {
            communityId: this.form.communityId,
            alarmTypeCd: this.form.alarmTypeCd,
            alarmLevel: this.form.alarmLevel,
            defaultHandlerId: this.form.defaultHandlerId.join(','), // 将数组转为逗号分隔的字符串
            handleTime: this.form.handleTime,
            overtimeWarning: this.form.overtimeWarning,
            returnVisitFlag: this.form.returnVisitFlag
          }
          if (this.form.remark) payload.remark = this.form.remark

          await saveAlarmSetting(payload)
          this.$message.success('添加成功')
          this.visible = false
          this.$emit('success')
        } catch (error) {
          this.$message.error(error.message || '添加失败')
        } finally {
          this.loading = false
        }
      })
    },
    getHandleTimeSuggestions(queryString, cb) {
      const suggestions = [
        { label: '10分钟', value: '10' },
        { label: '20分钟', value: '20' },
        { label: '30分钟', value: '30' },
        { label: '45分钟', value: '45' }
      ]
      cb(suggestions)
    },
    handleSelectTime(item) {
      // item.value 是分钟字符串，通过 handleTimeDisplay setter 自动转换为小时
      this.handleTimeDisplay = item.value
    }
  }
}
</script>

<style scoped>
.alarm-form { padding: 20px 24px 0; }
.alarm-form >>> .el-form-item { margin-bottom: 20px; }
.alarm-form >>> .el-form-item__label { color: #1D2129; font-weight: 400; }
.alarm-form >>> .el-input__inner, .alarm-form >>> .el-textarea__inner { border-radius: 8px; border-color: #DCE6F5; }
.dialog-footer { display: flex; justify-content: flex-end; gap: 12px; padding: 20px 24px; }
.alarm-btn-cancel, .alarm-btn-confirm { width: 80px; height: 38px; border-radius: 10px; }
.alarm-btn-cancel { color: #0E76FF; border-color: #0E76FF; background: #fff; }
.alarm-btn-confirm { background: #0E76FF; border-color: #0E76FF; }
.alarm-dialog >>> .el-dialog__header { height: 66px; padding: 0 24px; background: #ebf2fa; border-bottom: 1px solid #dce6f5; line-height: 66px; }
.alarm-dialog >>> .el-dialog__title { color: #1d2129; font-size: 16px; font-weight: 600; }
</style>

